function acs_showLoading() {
    const loading = document.querySelector(".acs_loading");
    if (loading) loading.style.display = "block";
}

function acs_hideLoading() {
    const loading = document.querySelector(".acs_loading");
    if (loading) loading.style.display = "none";
}

function acs_fetchPlp() {
    graphenehc.load({
        template        : { id: "category", target: ".acs_results" },
        include         : ["breadcrumb", "page"],
        init            : function() {
            acs_showLoading();
        },
        success         : function (response) {
            acs_hideLoading();
        }
    });
}

function acs_fetchSearch() {
    graphenehc.load({
        template        : { id: "search", target: ".acs_results" },
        include         : ["page"],
        init            : function() {
            acs_showLoading();
        },
        success         : function (response) {
            acs_hideLoading();
        }
    });
}

function acl_getNextPage(grapheneMainWrapper) {
    /* PLP get the items of the next page as 'load more' functionality (on scroll or button click) */
    let searchParams = new URLSearchParams(window.location.search);
    let next_page = parseInt(searchParams.get('pg') ?? 1) + 1;
    let load_more_btn = grapheneMainWrapper.querySelector("#acs_paging_btn");
    //console.log(SEARCH_ENTITY_CURRENT)

    graphenehc.load_page({
        page_number: next_page,
        set_page_url: true,
        init: function () {
            // custom code here - e.g. insert content loading icon
            load_more_btn.setAttribute("disabled", "disabled"); // Disable button onclick to prevent spamming
        },
        success: function (response) {
            let template = response.templates.category || response.templates.search;
            if(template.error){
              console.log(template.error);
              return false;
            }

            //acl_currPage = template.current_page;// current_page response is assigned to acl_currPage
            var template_html = new DOMParser().parseFromString(template.html, 'text/html');
            if(!template_html) return false;

            var load_more_btn_current = template_html.querySelector('#acs_paging_btn');
            if(load_more_btn_current.classList){
              load_more_btn.classList = load_more_btn_current.classList;
            }

            var pagination_info_text_wrapper = grapheneMainWrapper.querySelector('.pagination-info-text');
            var new_pagination_info_text = template_html.querySelector('.pagination-info-text')?.innerHTML;
            if(pagination_info_text_wrapper && new_pagination_info_text){
              pagination_info_text_wrapper.innerHTML = new_pagination_info_text;
            }

            grapheneMainWrapper.querySelectorAll(".collection-products__cards").forEach(results_wrapper => {
              var new_items_html = template_html.querySelector('.collection-products__cards[data-items-type='+ results_wrapper.dataset.itemsType +']')?.innerHTML;
              new_items_html = (new_items_html ?? "").trim();

              if(results_wrapper.dataset.itemsType == 'categories') {
                /*categories pager has no pagination for now*/
                return;
              }

              if(new_items_html){
                results_wrapper.innerHTML += new_items_html;
                if(results_wrapper.dataset.itemsType == 'products'){
                  document.dispatchEvent(new CustomEvent("swym:collections-loaded"));//activate scripts after elements loaded
                }
              }

            });

            load_more_btn.removeAttribute("disabled");// Enable button on success
            if (template.current_page >= template.page_count) {
                load_more_btn.setAttribute("disabled", "disabled"); // Disable button if last page
            }
        },
    });
}

function acl_getPageX(page_number, grapheneMainWrapper, default_page){
    if(!page_number || !grapheneMainWrapper)return;

    graphenehc.load_page({
        page_number: page_number,
        set_page_url: true,/*this had to be true to fetch correct products of this page, but will also change the page URL*/
        init: function () {
            // custom code here - e.g. insert content loading icon
        },
        success: function (response) {
            customUndoSetPageUrl(default_page);

            let template = response.templates.category || response.templates.search;
            if(template.error){
              console.log(template.error);
              return false;
            }

            var template_html = new DOMParser().parseFromString(template.html, 'text/html');
            if(!template_html) return false;

            grapheneMainWrapper.querySelectorAll(".collection-products__cards").forEach(results_wrapper => {
              var new_items_html = template_html.querySelector('.collection-products__cards[data-items-type='+ results_wrapper.dataset.itemsType +']')?.innerHTML;
              new_items_html = (new_items_html ?? "").trim();
              if(results_wrapper.dataset.itemsType == 'categories' || !new_items_html) {
                /*categories pager has no pagination for now*/
                return;
              }

              results_wrapper.innerHTML = new_items_html + results_wrapper.innerHTML;
            });
        },
    });
}
function customUndoSetPageUrl(default_page){
    /*related to graphenehc.load_page > set_page_url: if the page url and history have to remain same, but set_page_url:false does not work fully*/
    history.back();
}

function loadGrapheneCartRecommendations(graphene_element_id, graphene_current_currency, product_ids = ""){
    if(!graphene_element_id) return false;
    $g.load({
        elements: [{ id: graphene_element_id, target: "#cart-recommendations-graphene" }],
        page_context    : { currency_id: graphene_current_currency, product_id: product_ids },
        success         : function(response) {
            if(!response?.elements) {return false;}
            const cartRecommendations = document.getElementById('Cart-Drawer').querySelector('.product-recommendations--parent');
            cartRecommendations.classList.add('product-recommendations--full');
            if(document.getElementById('Cart-Drawer').classList.contains('active')){
              cartRecommendations.classList.add('active');
            }
        }
    });
}